import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const key = import.meta.env.VITE_REVERB_APP_KEY || 'dufiwaiterrealtimekey2025';
const envHost = import.meta.env.VITE_REVERB_HOST;
const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
// Si navegamos por IP local (LAN ej: 192.168.x.x) o localhost, conectar siempre al host que sirvió la página
const wsHost = (currentHostname && (!envHost || envHost === '127.0.0.1' || envHost === 'localhost'))
    ? currentHostname
    : (envHost || currentHostname || '127.0.0.1');
const wsPort = Number(import.meta.env.VITE_REVERB_PORT || 8001);
const scheme = import.meta.env.VITE_REVERB_SCHEME || (typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https' : 'http');
const isTls = scheme === 'https';

export const echo = new Echo({
    broadcaster: 'reverb',
    key: key,
    wsHost: wsHost,
    wsPort: wsPort,
    wssPort: wsPort,
    forceTLS: isTls,
    enabledTransports: ['ws', 'wss'],
});
